<template>
  <div class="container">
    <owa-usage-messages
      :message-groups="['dire']"
      type="kit"
    />
    <owa-usage-messages
      :message-groups="['dire']"
      type="npm"
      is-last
    />
  </div>
</template>
